// EmptyState.tsx - Empty state component for no scenarios

import React from 'react';
import { motion } from 'framer-motion';

interface EmptyStateProps {
  message: string;
  action?: string;
  onAction?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ message, action, onAction }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="text-center py-16"
    >
      <div className="w-24 h-24 bg-white/[0.05] rounded-full flex items-center justify-center mx-auto mb-6">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" className="text-slate-400">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
          <line x1="9" y1="9" x2="15" y2="15"/>
          <line x1="15" y1="9" x2="9" y2="15"/>
        </svg>
      </div>
      <h3 className="text-xl font-medium text-white mb-2">No scenarios found</h3>
      <p className="text-slate-300 mb-6 max-w-md mx-auto">{message}</p>
      {action && onAction && (
        <button
          onClick={onAction}
          className="bg-gradient-to-r from-professional-blue-600 to-professional-blue-700 text-white px-6 py-3 rounded-lg font-medium hover:shadow-lg transition-all duration-200 hover:-translate-y-0.5"
        >
          {action}
        </button>
      )}
    </motion.div>
  );
};

export default EmptyState;